export function determineTextColorByBgcolor(backgroundColor: string) {
  // set default
  let r = 255
  let g = 255
  let b = 255
  let a = 1

  // Check the format of the input color
  if (backgroundColor.startsWith('#')) {
    // Convert hex to RGB
    const color = backgroundColor.substring(1)
    r = parseInt(color.substring(0, 2), 16)
    g = parseInt(color.substring(2, 4), 16)
    b = parseInt(color.substring(4, 6), 16)
    if (color.length === 8) {
      a = parseInt(color.substring(6, 8), 16) / 255 // Alpha value from hex
    }
  } else if (
    backgroundColor.startsWith('rgb') &&
    backgroundColor.match(/\d+/g)
  ) {
    // Extract RGB values
    const rgb = backgroundColor.match(/\d+/g)!
    r = parseInt(rgb[0])
    g = parseInt(rgb[1])
    b = parseInt(rgb[2])
    a = rgb[3] !== undefined ? parseFloat(rgb[3]) : 1 // If alpha is not specified, assume fully opaque
  }

  // Interpolate the color with white based on the alpha value
  r = r * a + 255 * (1 - a)
  g = g * a + 255 * (1 - a)
  b = b * a + 255 * (1 - a)

  // Calculate relative luminance
  // Formula: 0.299*R + 0.587*G + 0.114*B
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b

  // Black text on light backgrounds, white text on dark backgrounds
  return luminance > 128 ? 'black' : 'white'
}
